import script from "./PrivateSettingsMembers.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivateSettingsMembers.vue?vue&type=script&setup=true&lang=js"

import "./PrivateSettingsMembers.vue?vue&type=style&index=0&id=f9b3558a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9b3558a"]])

export default __exports__